import { Instructor } from "./instructor";
import Listing from "./listing.ts";

export interface EventInstructorInterface {
    id: number;
    documentId: string;
    title: string | null;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    time?: string | null;
    lastSeen?: string | null;
    instructor: Instructor;
    listing: Listing | null;
}

export class EventInstructor implements EventInstructorInterface {
    id: number;
    documentId: string;
    title: string | null;
    createdAt: string;
    updatedAt: string;
    publishedAt: string;
    time?: string | null;
    lastSeen?: string | null;
    instructor: Instructor;
    listing: Listing | null;

    constructor(params: Partial<EventInstructorInterface> = {}) {
        this.id = params.id ?? 0;
        this.documentId = params.documentId ?? "";
        this.title = params.title ?? null;
        this.createdAt = params.createdAt ?? "";
        this.updatedAt = params.updatedAt ?? "";
        this.publishedAt = params.publishedAt ?? "";
        this.time = params.time ?? null;
        this.lastSeen = params.lastSeen ?? null;
        this.instructor = params.instructor ?? {} as Instructor;
        this.listing = params.listing ?? Listing.active;
    }
}